/**
 * OptimizedImage Component
 * Serves WebP images with PNG fallback for better performance
 */
import { useState } from 'react';

const OptimizedImage = ({ 
  src, 
  alt, 
  className = '', 
  width,
  height,
  loading = 'lazy',
  priority = false,
  ...props 
}) => {
  const [error, setError] = useState(false);
  
  // Convert PNG path to WebP path
  const webpSrc = src.replace(/\.png$/, '.webp').replace(/\.jpg$/, '.webp');
  const isWebPAvailable = src.endsWith('.png') || src.endsWith('.jpg');
  
  // Handle image load error - fallback to original
  const handleError = () => {
    setError(true);
  };

  // If WebP failed or not available, use original
  if (error || !isWebPAvailable) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        width={width}
        height={height}
        loading={priority ? 'eager' : loading}
        decoding="async"
        {...props}
      />
    );
  }

  return (
    <picture>
      <source type="image/webp" srcSet={webpSrc} />
      <img
        src={src}
        alt={alt}
        className={className}
        width={width}
        height={height}
        loading={priority ? 'eager' : loading}
        decoding="async"
        onError={handleError}
        {...props}
      />
    </picture>
  );
};

export default OptimizedImage;
